import React from 'react';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export interface IDashboardLinkedCampaignListProps {
    children: JSX.Element;
    nbCampaigns?: number;
}

export function DashboardLinkedCampaignList({ children, nbCampaigns }: IDashboardLinkedCampaignListProps) {
    const { t } = useTranslation();

    return (
        <Table className="table-vertical-center dashboard-table mb-0">
            <thead className="border-bottom position-sticky z-index-1 bg-white top-0">
                <tr>
                    <th className="text-start sticky-table-header">
                        {t('brand.campaign.dashboard.contracts.linked_campaigns', { nbCampaigns })}
                    </th>
                    <th className="text-center sticky-table-header">
                        {t('brand.campaign.dashboard.contracts.creators')}
                    </th>
                    <th className="text-center sticky-table-header">
                        {t('brand.campaign.dashboard.contracts.postings')}
                    </th>
                    <th className="text-center sticky-table-header">{t('brand.campaign.dashboard.contracts.reach')}</th>
                    <th className="text-center sticky-table-header">
                        {t('brand.campaign.dashboard.contracts.eng_rate')}
                    </th>
                    <th className="text-center sticky-table-header">
                        {t('brand.campaign.dashboard.contracts.managers')}
                    </th>
                    <th className="text-center sticky-table-header">
                        {t('brand.campaign.dashboard.contracts.partners')}
                    </th>
                    <th className="text-end sticky-table-header">{t('brand.campaign.dashboard.contracts.actions')}</th>
                </tr>
            </thead>
            <tbody>{children}</tbody>
        </Table>
    );
}
